import type { FC, SVGProps } from 'react'

export const HighPass: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.07278 10.1541C7.32371 8.9177 9.15894 8.25 11.5 8.25H19C19.4142 8.25 19.75 8.58579 19.75 9C19.75 9.41421 19.4142 9.75 19 9.75H11.5C9.44106 9.75 8.02629 10.3323 7.12722 11.2209C6.22766 12.11 5.75 13.3989 5.75 15C5.75 15.4142 5.41421 15.75 5 15.75C4.58579 15.75 4.25 15.4142 4.25 15C4.25 13.1011 4.82234 11.39 6.07278 10.1541Z"
      fill="currentColor"
    />
  </svg>
)
